<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <core-dashboard-view />

    <core-footer />

  </v-app>
</template>

<script>
export default {
  name: 'Resources',

  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    CoreDashboardView: () => import('../components/core/DashboardView'),
    CoreFooter: () => import('../components/core/Footer'),
  },

  data: () => ({
    expandOnHover: false,
  }),
}
</script>
